<template>
  <div>
    <h5 class="blue-text">{{ L10n('sale-orders') }}:</h5>
    <el-table :fit="true" :data="salesOrders" border size="mini" style="width: 100%">
      <el-table-column prop="shippingPorformaNumber" :label="L10n('shipping-porforma-number')" />
      <el-table-column prop="awb" :label="L10n('awb')" />
      <el-table-column prop="remarks" :label="L10n('remarks')" />
      <el-table-column prop="poStillOpen" :label="L10n('po-still-open')">
        <template slot-scope="scope">
            <el-checkbox :value="scope.row.poStillOpen" />
      </template>
      </el-table-column>
      <el-table-column fixed="right" width="60">
        <template slot-scope="scope">
            <el-button
                @click.native.prevent="openRow(scope.$index, salesOrders)"
                type="text"
                size="small">
                {{ L10n('eidt') }}
            </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'SaleOrders',
  props: {
    salesOrders: {
      type: Array,
      required: true
    }
  },
  methods: {
    openRow (index, rows) {
      const row = rows[index]
      const isOpen = row.poStillOpen

      const route = {
        name: !isOpen ? 'SupplierPoWoOpen' : 'SupplierPoWoClose',
        query: {
          'supplier-quotes-rfq2-chosen-true': `edit[${row.id}]`
        }
      }

      const fullPath = this.$router.resolve(route).href
      window.open(fullPath, '_blank')
    }
  }
}
</script>
